import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import home from '@core/components/content/home'
import blog from '@core/components/content/blog'
import blogpost from '@core/components/content/blogpost'
import services from '@core/components/content/services'
import contact from '@core/components/content/contact'
// import details from '@core/components/content/details'
import sign_in from '@core/components/content/app/sign_in'
import sign_up from '@core/components/content/app/sign_up'
import price from '@core/components/content/price'
import forgot_password from '@core/components/content/app/forgot_password'
import terms from '@core/components/content/terms'
import privacy from '@core/components/content/privacy'
import imprint from '@core/components/content/imprint'
import app from '@core/components/content/app/app'
import logout from '@core/components/content/app/logout'
import feedbacks from '@core/components/content/app/feedbacks'
import feedback from '@core/components/content/app/feedback'
import feedback_details from '@core/components/content/app/feedback/feedback_detail'
import embed from '@core/components/content/app/embed'
import boards from '@core/components/content/app/boards'
import board_settings from '@core/components/content/app/board/board_settings'
import board_targetpage from '@core/components/content/app/board/board_targetpage'
import landingpage from '@core/components/content/landingpage/index'
import profile from '@core/components/content/app/profile'
import register_confirm from '@core/components/content/app/register_confirm'
import vote_confirm from '@core/components/content/app/vote_confirm'
import vote_conflict from '@core/components/content/app/vote_conflict'
import unread_chats from '@core/components/content/app/unread_chats'
import hitorshit from '@core/components/hitorshit/'
import cookie from '@core/components/cookie'

Vue.use(Router)
Vue.use(Meta)

export default new Router({

  mode: 'history',
  base: '/v1',
  routes: [
    {
      path: '/',
      redirect: '/de/'

    },
    {
      path: '/:lang/app/dashboard.html',
      name: 'app',
      component: app
    },
    {
      path: '/:lang/cookie.html',
      name: 'cookie',
      component: cookie
    },
    {
      path: '/:username/:lang/:boardID/index.html',
      name: 'landingpage',
      component: landingpage
    },
    {
      path: '/:lang/:userID/confirm.html',
      name: 'register_confirm',
      component: register_confirm
    },
    {
      path: '/:lang/:userID/:boardID/:entryID/confirm.html',
      name: 'vote_confirm',
      component: vote_confirm
    },
    {
      path: '/:lang/app/feedbacks.html',
      name: 'feedbacks',
      component: feedbacks
    },
    {
      path: '/:lang/app/:boardID/:entryID/details.html',
      name: 'feedback_details',
      component: feedback_details
    },
    {
      path: '/:userID/:boardID/:entryID/conflict.html',
      name: 'vote_conflict',
      component: vote_conflict
    },
    {
      path: '/:lang/app/embed/:boardID.html',
      name: 'embed',
      component: embed
    },
    {
      path: '/:lang/app/feedback/:board/:id.html',
      name: 'feedback',
      component: feedback
    },
    {
      path: '/:lang/app/profile.html',
      name: 'profile',
      component: profile
    },
    {
      path: '/:lang/app/feedback/:board.html',
      name: 'feedback_board',
      component: feedback
    },
    {
      path: '/:lang/app/boards.html',
      name: 'boards',
      component: boards
    },
    {
      path: '/:lang/app/board/:id/settings.html',
      name: 'board_settings',
      component: board_settings
    },
    {
      path: '/:lang/app/board/:id/targetpage.html',
      name: 'board_targetpage',
      component: board_targetpage
    },
    {
      path: '/:lang/app/logout.html',
      name: 'logout',
      component: logout,
      meta: {title: 'Logout'}
    },
    {
      path: '/:lang/',
      name: 'home',
      component: home,
      meta: {title: 'Home'}
    },
    {
      path: '/:lang/terms.html',
      name: 'terms',
      component: terms
    },
    {
      path: '/:lang/app/hitorshit.html',
      name: 'hitorshit',
      component: hitorshit
    },
    {
      path: '/:lang/privacy.html',
      name: 'privacy',
      component: privacy
    },
    {
      path: '/:lang/imprint.html',
      name: 'imprint',
      component: imprint
    },
    {
      path: '/:lang/forgot-password.html',
      name: 'forgot_password',
      component: forgot_password
    },
    {
      path: '/:lang/sign-in.html',
      name: 'sign_in',
      component: sign_in
    },
    {
      path: '/:lang/sign-up.html',
      name: 'sign_up',
      component: sign_up
    },
    {
      path: '/:lang/price.html',
      name: 'price',
      component: price
    },
    {
      path: '/:lang/blog.html',
      name: 'blog',
      component: blog
    },
    {
      path: '/:lang/blog/:id/:title.html',
      name: 'blogpost',
      component: blogpost
    },
    {
      path: '/:lang/services.html',
      name: 'services',
      component: services
    },
    {
      path: '/:lang/contact.html',
      name: 'contact',
      component: contact
    },
    {
      path: '/:lang/unread_chats.html',
      name: 'unread_chats',
      component: unread_chats
    }

  ]
})
